export default "__VITE_ASSET__DuAf6BvJ__"